import React, { useMemo } from 'react';
import { useLocation, Link } from 'react-router-dom';
import './ModuleNavbar.css';

const MODULES = [
  {
    name: "Machine Health (PM)",
    basePath: ["/home/pm", "/home/settings/pm-masters"],
    links: [
      { label: "PM Standards", path: "/home/settings/pm-masters/pmStandards" },
      { label: "PM Calendar", path: "/home/pm/calendar" },
      { label: "My PM Tasks", path: "/home/pm/operator-tasks" },
    ]
  },
  {
    name: "Work Orders",
    basePath: ["/home/work-order", "/home/work-order-wizard"],
    links: [
      { label: "Work Orders List", path: "/home/work-order" },
      { label: "Create Work Order", path: "/home/work-order-wizard" },
    ]
  },
  {
    name: "Work Permits",
    basePath: ["/home/work-permits"],
    links: [
      { label: "Dashboard", path: "/home/work-permits/dashboard" },
      { label: "Permit List", path: "/home/work-permits" },
      { label: "Create Permit", path: "/home/work-permits/new" },
      { label: "Permit Reports", path: "/home/work-permits/reports/status" },
    ]
  },
  {
    name: "Spares & Inventory",
    basePath: ["/home/inventory", "/home/spare-parts"],
    links: [
      { label: "Dashboard", path: "/home/inventory/dashboard" },
      { label: "Spare Parts Data", path: "/home/spare-parts" },
      { label: "Transaction History", path: "/home/inventory/history" },
    ]
  },
  {
    name: "Safety Observation",
    basePath: [
      "/home/safety-observation", 
      "/home/safety-observation-entry", 
      "/home/safety-observation-actions",
      "/home/settings/safety-behavior-categories"
    ],
    links: [
      // { label: "Dashboard", path: "/home/safety-observation/dashboard" },
      { label: "Schedule", path: "/home/safety-observation/schedule" },
      { label: "Safety Categories", path: "/home/settings/safety-behavior-categories" },
      { label: "Settings", path: "/home/safety-observation/settings" },
    ]
  },
  {
    name: "Hazard Reporting",
    basePath: ["/home/hazard-reports", "/home/settings/hazard-categories"],
    links: [
      // { label: "Analytics Dashboard", path: "/home/hazard-reports/analytics" },
      { label: "Hazard Log", path: "/home/hazard-reports" },
      { label: "Hazard Categories", path: "/home/settings/hazard-categories" },
      { label: "Settings", path: "/home/hazard-reports/settings" },
    ]
  },
  {
    name: "Incident Management",
    basePath: ["/home/incident"],
    links: [
      { label: "Dashboard", path: "/home/incident/analytics" },
      { label: "Summary", path: "/home/incident/dashboard" },
    ]
  },
  {
    name: "Production & Downtime (OEE)",
    basePath: ["/home/oee", "/home/breakdown-log", "/home/loss-reasons"],
    links: [
      { label: "OEE Dashboard", path: "/home/oee" },
      { label: "Breakdown Log", path: "/home/breakdown-log" },
      { label: "Reasons", path: "/home/loss-reasons" },
      { label: "Settings", path: "/home/oee/settings" },
    ]
  },
  {
    name: "5Why & Root Cause Analysis",
    basePath: ["/home/rca"],
    links: [
      { label: "RCA Records", path: "/home/rca" },
      { label: "Fishbone Analysis", path: "/home/rca/fishbone" },
      { label: "5-Whys Analysis", path: "/home/rca/five-whys" },
    ]
  },
  {
    name: "CAPA",
    basePath: ["/home/capa"],
    links: [
      { label: "CAPA Records", path: "/home/capa" },
      { label: "Task Management", path: "/home/capa/task-management" },
    ]
  },
  {
    name: "Kaizen",
    basePath: ["/home/kaizen"],
    links: [
      { label: "Kaizen Ideas", path: "/home/kaizen" },
    ]
  }
];

/** Pathname matches this nav link (exact or nested under it). */
function pathMatchesLink(pathname, linkPath) {
  if (pathname === linkPath) return true;
  if (pathname.startsWith(`${linkPath}/`)) return true;
  return false;
}

/**
 * When multiple tabs match (e.g. /home/hazard-reports vs /home/hazard-reports/settings),
 * only the longest matching path should be active.
 */
function getActiveLinkPath(links, pathname) {
  const matches = links.filter((link) => pathMatchesLink(pathname, link.path));
  if (matches.length === 0) return null;
  return matches.reduce((best, link) =>
    link.path.length > best.path.length ? link : best
  ).path;
}

const ModuleNavbar = () => {
  const location = useLocation();

  const activeModule = useMemo(() => {
    // Hide module navbar on all report pages for a cleaner reporting UI
    if (location.pathname.includes('/reports')) return null;

    return MODULES.find(module =>
      module.basePath.some(
        (path) =>
          location.pathname === path ||
          location.pathname.startsWith(`${path}/`)
      )
    );
  }, [location.pathname]);

  const activeLinkPath = useMemo(() => {
    if (!activeModule) return null;
    return getActiveLinkPath(activeModule.links, location.pathname);
  }, [activeModule, location.pathname]);

  if (!activeModule) return null;

  return (
    <div className="module-navbar-wrapper">
      <div className="module-navbar-container">
        {activeModule.links.map((link) => {
          const isActive = activeLinkPath === link.path;

          return (
            <Link
              key={link.path}
              to={link.path}
              className={`module-nav-item ${isActive ? 'active' : ''}`}
            >
              {link.label}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default ModuleNavbar;
